import { configureStore } from '@reduxjs/toolkit';
import {orderReducer} from './appReducer';

export const store = configureStore({
  reducer: {
    order: orderReducer
  }
});
